import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { TRANSLATIONS, WHY_US_T, FACILITY_LABELS } from "./translations";

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: (k) => k,
  toggle: () => {},
  whyUs: WHY_US_T.en,
  facilityLabel: (k) => k,
});

const STORAGE_KEY = "mec_lang";

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState("en");

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === "ml" || saved === "en") setLangState(saved);
    } catch (_e) {
      /* ignore */
    }
  }, []);

  const setLang = useCallback((next) => {
    setLangState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (_e) {
      /* ignore */
    }
  }, []);

  const toggle = useCallback(() => {
    setLang(lang === "en" ? "ml" : "en");
  }, [lang, setLang]);

  const t = useCallback(
    (key) => {
      const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;
      return dict[key] ?? TRANSLATIONS.en[key] ?? key;
    },
    [lang]
  );

  const facilityLabel = useCallback(
    (key) => (FACILITY_LABELS[lang] || FACILITY_LABELS.en)[key] || key,
    [lang]
  );

  const whyUs = WHY_US_T[lang] || WHY_US_T.en;

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, whyUs, facilityLabel }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useT = () => useContext(LanguageContext);
